import {combineReducers } from 'redux';
import * as NavigationReducer from './navigation';
import * as dataReducer from './data';


export default combineReducers(Object.assign(
    NavigationReducer,
    dataReducer
))
